import React, { useCallback, useMemo } from 'react';
import { useTheme, useMergeClasses } from '../../../../theme';
import { useTranslation } from 'react-i18next';
import { useConfig } from '../../../../context';
import AgreementCheckboxWrapper from '../../../../AgreementCheckboxWrapper';
import { BaseButton } from '../../../../BaseComponents';
import CdnImage from '../../../../CdnImage';
import { SafeHtml } from '@shared/ui';
const FirstLoginAgreement = ({ classes, checkboxes: initialCheckboxes, loading, onConfirm }) => {
    const { FirstLoginAgreement: defaultClasses } = useTheme('LoginPage');
    const css = useMergeClasses(defaultClasses, classes);
    const { t } = useTranslation('LoginPage');
    const { global: { companyInfo } } = useConfig();
    const checkboxes = useMemo(() => {
        if ((initialCheckboxes === null || initialCheckboxes === void 0 ? void 0 : initialCheckboxes.length) > 0) {
            return initialCheckboxes;
        }
        const defaultCheckboxes = [
            {
                fieldName: 'agreement',
                label: (React.createElement(SafeHtml, { tag: "span", className: css.checkbox__label, html: t('FirstLoginAgreement_Checkbox_Label', {
                        privacyPolicy: companyInfo.privacyPolicy
                    }) })),
                required: true
            }
        ];
        return defaultCheckboxes;
    }, [t, initialCheckboxes, companyInfo]);
    const renderButton = useCallback(({ isValid }) => {
        const handleConfirm = () => {
            if (!isValid) {
                return;
            }
            onConfirm();
        };
        return (React.createElement(BaseButton, { className: css.button, disabled: !isValid, isLoading: loading, onClick: handleConfirm, variant: "action" }, t('FirstLoginAgreement_Button')));
    }, [t, onConfirm, loading]);
    return (React.createElement("div", { className: css.root },
        React.createElement(AgreementCheckboxWrapper, { classes: {
                footer_wrapper: css.footer_wrapper,
                checkboxes_wrapper: css.checkboxes_wrapper
            }, checkboxes: checkboxes, showTooltip: false, renderButton: renderButton }, () => (React.createElement("div", { className: css.content },
            React.createElement("div", { className: css.title },
                React.createElement(CdnImage, { className: css.emojy, path: "https://cdn.websky.aero/content/frontend/images/emojy/hello.svg" }),
                t('FirstLoginAgreement_Title')),
            React.createElement("div", { className: css.message }, t('FirstLoginAgreement_Description')))))));
};
export default FirstLoginAgreement;
